import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bc35ed6c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bc35ed6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc35ed6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc35ed6c')) {
      api.createRecord('bc35ed6c', component.options)
    } else {
      api.reload('bc35ed6c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bc35ed6c&scoped=true&", function () {
      api.rerender('bc35ed6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Fsngc5EpV7S/JS/comp/DocBox.vue"
export default component.exports